"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentRoot = exports.setApiRoot = void 0;
var urlvalues = {
    baseUrl: '',
    admin: {
        admin: 'api/admin/admin',
        log: 'api/admin/log',
        organization: 'api/admin/organization',
        stats: 'api/admin/stats',
        taskEngine: 'api/admin/taskEngine',
    },
    app: {
        auth: 'api/app/auth',
        message: 'api/app/message',
        program: 'api/app/program',
        public: 'api/app/public',
        preview: 'api/app/preview',
        user: 'api/app/user',
        sensor: 'api/app/sensor',
        sleep: 'api/app/sleep',
        activity: 'api/app/activity',
        media: 'api/app/media',
        external: 'api/app/external/user',
    },
    fihr: {
        observation: 'api/fihr/observation',
    },
    portal: {
        patient: 'api/portal/patient',
        patientSensor: 'api/portal/patient/sensor',
        patientExport: 'api/portal/patient/export',
        patientFitbit: 'api/portal/patient/fitbit',
        patientGarmin: 'api/portal/patient/garmin',
        patientMessage: 'api/portal/patient/message',
        patientGroupMessage: 'api/portal/patient/message/group',
        patientEvent: 'api/portal/patient/event',
        patientNotification: 'api/portal/patient/notifications',
        patientMedia: 'api/portal/patient/media',
        patientAdmin: 'api/portal/patient/admin',
        module: 'api/portal/program/module',
        program: 'api/portal/program/program',
        task: 'api/portal/program/task',
        import: 'api/portal/program/import',
        programExport: 'api/portal/program/export',
        auth: 'api/portal/auth',
        media: 'api/portal/media',
        registration: 'api/portal/registration',
        user: 'api/portal/user',
        users: 'api/portal/users',
        content: 'api/portal/content',
        analytics: 'api/portal/analytics',
        organization: 'api/portal/organization',
    },
    public: {
        program: 'api/public/program',
    },
    media: {
        file: 'media/file',
        video: 'media/video',
    },
    route: {
        callback: 'route/callback',
        oauth: 'route/oauth',
    },
    socket: {
        videoChat: 'socket/videochat/hub',
    },
};
var apiUrls = __assign({}, urlvalues);
var setApiRoot = function (baseUrl) {
    apiUrls.baseUrl = baseUrl;
};
exports.setApiRoot = setApiRoot;
var currentRoot = function () { return "".concat(window.location.protocol, "//").concat(window.location.host); };
exports.currentRoot = currentRoot;
exports.default = apiUrls;
